import { render, staticRenderFns } from "./SmsCertCode.vue?vue&type=template&id=5914e8f5&scoped=true&"
import script from "./SmsCertCode.vue?vue&type=script&lang=ts&"
export * from "./SmsCertCode.vue?vue&type=script&lang=ts&"
import style0 from "./SmsCertCode.vue?vue&type=style&index=0&id=5914e8f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5914e8f5",
  null
  
)

export default component.exports